/**
 * Application geometry options.
 * Automatically loaded on application initialization and available as app.metrics.
 */

'use strict';

var metrics = {
    480: {
        epgGrid: 6,
        scheduleWidth: 372,
        timeStep: 90 * 60,
        countOfSteps: 3,
        timeLineMargin: 250,
        itemHeight: 38,
        timeLineTop: 2
    },

    576: {
        epgGrid: 9,
        scheduleWidth: 372,
        timeStep: 90 * 60,
        countOfSteps: 3,
        timeLineMargin: 250,
        itemHeight: 38,
        timeLineTop: 2
    },

    720: {
        epgGrid: 9,
        scheduleWidth: 830,
        timeStep: 150 * 60,
        countOfSteps: 5,
        timeLineMargin: 350,
        itemHeight: 48,
        timeLineTop: 2
    },

    1080: {
        epgGrid: 9,
        scheduleWidth: 1245,
        timeStep: 150 * 60,
        countOfSteps: 5,
        timeLineMargin: 350 * 1.5,
        itemHeight: 48 * 1.5,
        timeLineTop: 2
    }
};

// public
module.exports = metrics[screen.height];
